import {
  usePublishStepPayload,
  type StepPayload,
} from "./step-payload-context";

/**
 * Publishes the step's payload from inside a Formik render, where a hook cannot be
 * called directly. Renders nothing.
 */
export const PublishStepPayload = ({
  payload,
}: {
  payload: StepPayload | undefined;
}) => {
  usePublishStepPayload(payload);
  return null;
};
